import { apiFetch } from "@/utils";


function getCaVente(tierSdcGuid) {
  return apiFetch("member/ca-vente?tierSdcGuid=" + tierSdcGuid);
}

function updateCaVente(socGuid, caVenteN1, caVenteN) {
  return apiFetch("member/update-ca-vente?socGuid=" + socGuid + "&caVenteN1=" + caVenteN1 + "&caVenteN=" + caVenteN);
}

export default {
  getCaVente,
  updateCaVente
}
export {
  getCaVente,
  updateCaVente
}



// WEBPACK FOOTER //
// ./src/utils/caVente.js